import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BreadcrumbItem {
  title: string | JSX.Element; // Title can be a string or a React element
}

// Create a Context with a default value of an empty array
interface BreadcrumbsContextType {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: React.Dispatch<React.SetStateAction<BreadcrumbItem[]>>;
}

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | undefined>(undefined);

// Create a provider component
interface BreadcrumbsProviderProps {
  children: ReactNode;
}

export const BreadcrumbsProvider: React.FC<BreadcrumbsProviderProps> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};


export const useBreadcrumbs = (): BreadcrumbsContextType => {
  const context = useContext(BreadcrumbsContext);
  if (!context) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider');
  }
  return context;
};